<template>
  <div class="flex flex-center full-width column q-pa-md q-gutter-y-md" style="min-height: 80vh">
    <q-img src="@/assets/logo.png" width="175px"/>
    <div class="text-weight-medium">مركز الاشراق</div>
    <q-form class="q-gutter-y-md" style="width: 275px" greedy @submit="login()">
      <q-input v-model="id" outlined label="المعرف" :rules="[val => !!val || 'الحقل مطلوب']"/>
      <q-input
        v-model="pass"
        outlined
        class="full-width"
        label="كلمة المرور"
        :rules="[val => !!val || 'الحقل مطلوب',val => val.length >= 8 || 'برجاء التاكد من صحة البينات']"
        :type="isPwd ? 'password' : 'text'"
      >
        <template v-slot:append>
          <q-icon
            :name="isPwd ? 'visibility_off' : 'visibility'"
            class="cursor-pointer"
            @click="isPwd = !isPwd"
          />
        </template>
      </q-input>
      <q-btn
        class="full-width"
        label="تسجيل الدخول"
        style="background: linear-gradient(45deg,#20E988, #65CBE1)"
        type="submit"
      />
    </q-form>
  </div>
</template>

<script>
import { ref } from "vue"
import { loginAction } from "@/action/auth.action";
import { basicStore } from "@/store/basic.store";
export default {
  name: "LoginView",
  data(){
    return{
      store2:basicStore(),
      id:ref(""),
      pass: ref(""),
      isPwd:ref(true)
    }
  },
  methods:{
    async login(){
      await loginAction(this.id,this.pass)
    }
  }
};
</script>

<style scoped>

</style>